import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ShowResponse from "./ShowResponse";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { VarName } from "types/variable";
import UsuarioContext from "context/usuario/usuarioContext";
import Button from "@material-ui/core/Button";
import AlertasDispositivoContext from "context/alertas-dispositivo/alertasDispositivoContext";

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "85vh",
    width: "98%",
    marginRight: "5em",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  text: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  form: {
    minHeight: "100%",
    width: "98%",
    flexGrow: 1,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: "red",
  },
}));

export default function EditarAlerta({ setOpen, init, elegido, alerta }) {
  const classes = useStyles();

  const usuarioContext = useContext(UsuarioContext);
  const { obtenerUsuariosRol } = usuarioContext;

  const [state, setState] = useState({ supervisada: "", mensajeAlerta: "" });

  const [changed, setChanged] = useState(false)
  const [callback, setCallback] = useState({ msg: "", request: "" });
  const [actualPolicia, setActualPolicia] = useState('');
  const [statePolicia, setStatePolicia] = useState('');
  const [listaSupervisores, setListaSupervisores] = useState([]);

  const alertasDispositivoContext = useContext(AlertasDispositivoContext);
  const {
    editarAlertaDispositivo
  } = alertasDispositivoContext;

  const defaultMSG = `Usted posee una alerta del dispositivo: ${alerta?.nombreDispositivo}.`;
  ///////////////////////////////////////////
  ////////// funciones ///////////////
  const fetchData = async () => {

    const supervisores = await obtenerUsuariosRol("SUPERVISOR")
    if (supervisores != null) {
      armarListaSupervisores(supervisores)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (alerta) {
      setState(alerta);
    }
  }, [alerta])

  const [silobolsa, setSilobolsa] = useState();
  const esSiloBolsa = (modelo) => {
    setSilobolsa(modelo.nombre === "SB-100" ||
      modelo.nombre === "SB-101" ||
      modelo.nombre === "FIELD L-Silo" ||
      modelo.nombre === "L-Move" ||
      modelo.nombre === "L-Silo");
  };

  const armarListaSupervisores = (x) => {
    let data = x.map((us) => {
      if (us?.usuario) {
        return {
          nombre: us.usuario.nombre,
          id: us.usuario.id,
        }
      }
    });
    setListaSupervisores(data);
  };

  const handleSupervision = (e) => {
    setState({
      ...state,
      supervisablePolicia: e.target.value !== "LOCAL",
      supervisada: e.target.value
    });
  };

  const handleComparacion = (e) => {
    setState({
      ...state,
      tipoComparacion: e.target.value,
    })
  }

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleChangePolicia = (event) => {
    setChanged(true)
    setStatePolicia({
      id: event.target.value.id,
      nombre: event.target.value.nombre,
    });
    setState({
      ...state,
      usuarioSupervisor: event.target.value.id,
    })
  };

  const onChange = (e) => {
    setCallback({ msg: "", request: "" });
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleMovimiento = (e) => {
    setState({
      ...state,
      valorComparacion: e.target.value,
    });
  };

  const onChangeMSG = (e) => {
    setState({
      ...state,
      mensajeAlerta: e.target.value,
    });
  };

  const onSubmit = () => {
    let toSave;

    // Validar que no haya campos vacios
    if (state.supervisada === "NO" && state.enviaMail === "" && state.enviaSMS === "") {
      setCallback({
        ...callback,
        msg: "*Debe poseer al menos un nivel de supervision",
      });
    }  else if (state.tipoComparacion === "" || state.valorComparacion === "") {
      setCallback({
        ...callback,
        msg: "*Debe elegir que valores supervisar",
      });
    } else {
      setCallback({
        ...callback,
        msg: "",
      });
      toSave = state;
      if (toSave.supervisada === "POLICIAL" || toSave.supervisada === "NO") {
        toSave.enviaSMS = false;
        toSave.enviaMail = false;
      }
      if (state.referenciaNodo === VarName.Movimiento) {
        toSave.tipoComparacion = "=";
      }
      if (
        toSave.enviaMail !== "" ||
        toSave.enviaSMS !== "" ||
        toSave.enviaMailOld !== "" ||
        toSave.enviaSMSOld !== ""
      ) {
        if (toSave.mensajeAlerta === "") {
          toSave.mensajeAlerta = defaultMSG;
        }
      }
      toSave.usuarioSupervisor = statePolicia?.id;
      toSave.dispositivoId = state.dispositivoId;
      editarAlertaDispositivo(toSave)/* .then((value) => setCallback(value)) */;
    }
    init();
  };
  //{'=':'=', '>=':'>=', '>':'>', '!=':'!=', '<':'<', '<=':'<='}
  const comparacionArray = ["=", ">=", ">", "!=", "<", "<="];

  const comparacionATexto = (x) => {
    switch (x) {
      case "=":
        return "igual a ";
        break;
      case ">=":
        return "mayor o igual a ";
        break;
      case ">":
        return "mayor a ";
        break;
      case "!=":
        return "distinto a ";
        break;
      case "<":
        return "menor a ";
        break;
      case "<=":
        return "menor o igual a ";
        break;
      default:
        return " ";
        break;
    }
  };

  return (
    <div style={{ padding: "1em" }}>
      <div noValidate autoComplete="off" onSubmit={onSubmit}>
        <Grid
          container
          direction="row-reverse"
          justify="center"
          alignItems="start"
          spacing={2}
        >
          <Grid item xs={12} md={12} lg={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="supervisada">Supervision</InputLabel>
              {state.supervisada ?
                <Select
                  labelId="supervisada"
                  id="supervisada"
                  value={state.supervisada}
                  onChange={handleSupervision}
                  label="supervisada"
                >
                  <MenuItem value="LOCAL">Notificaciones al usuario</MenuItem>
                  {/* <MenuItem value="POLICIAL">
                    Notificaciones a la policia
                  </MenuItem>
                  <MenuItem value="COMPARTIDA">Ambas notificaciones</MenuItem> */}
                </Select>
                :
                <Select
                  labelId="supervisada"
                  id="supervisada"
                  value={state.supervisada}
                  onChange={handleSupervision}
                  label="supervisada"
                >
                  <MenuItem value="LOCAL">Notificaciones al usuario</MenuItem>
                </Select>
              }
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            {state.supervisablePolicia ? (
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="DistritoPolicial"> {actualPolicia.nombre !== "" && !changed ? actualPolicia.nombre : "Distrito Policial"}</InputLabel>
                <Select
                  labelId="DistritoPolicial"
                  id="DistritoPolicial"
                  value={statePolicia.nombre}
                  onChange={handleChangePolicia}
                  label="DistritoPolicial"
                >
                  {listaSupervisores.length === 0 ? (
                    <MenuItem value="">
                      <em>No posee distritos registrados</em>
                    </MenuItem>
                  ) : (
                    listaSupervisores.map((p) => (
                      <MenuItem value={p}>{p.nombre}</MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            ) : (
              <TextField
                variant="outlined"
                fullWidth
                disabled
                labelId="tipoPolicia"
                id="tipoPolicia"
                label="Distrito Policial"
              />
            )}
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Grid container direction="row" justify="center" alignItems="start">
              {/* {!silobolsa && (
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  style={{
                    textAlign: "center",
                    paddingBottom: "0px",
                    marginBottom: "0px",
                  }}
                >
                  <h5 style={{ paddingBottom: "0px", marginBottom: "0px" }}>
                    Alertar cuando: 
                  </h5>
                </Grid>
              )} */}
              {state.referenciaNodo !== VarName.Movimiento && !silobolsa && (
                <Grid
                  item
                  xs={8}
                  md={6}
                  lg={6}
                  style={{ paddingRight: "1.5em" }}
                >
                  {state.tipoComparacion && (
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                      <InputLabel id="supervisada">Alertar cuando sea</InputLabel>
                      <Select
                        labelId="tipoComparacion"
                        id="tipoComparacion"
                        value={state.tipoComparacion}
                        onChange={handleComparacion}
                        label="tipoComparacion"
                      >
                        {comparacionArray.map((x, index) => {
                          return (
                            <MenuItem key={index} value={x}>
                              {comparacionATexto(x)}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  )}
                </Grid>
              )}
              {state.referenciaNodo !== VarName.Movimiento && !silobolsa ? (
                <Grid item xs={3} md={6} lg={6}>
                  {state.tipoComparacion ? (
                    <TextField
                      style={{ marginTop: "0px" }}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="valorComparacion"
                      name="valorComparacion"
                      label={
                        state.tipoComparacion
                          ? comparacionATexto(state.tipoComparacion)
                          : ""
                      }
                      value={state.valorComparacion}
                      onChange={onChange}
                    />
                  ) : (
                    <h5 className={classes.error}>
                      Porfavor seleccione una condición
                    </h5>
                  )}
                </Grid>
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  {state.referenciaNodo === VarName.Movimiento && !silobolsa ? (
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                      <InputLabel id="supervisada">Alertar cuando</InputLabel>
                      <Select
                        labelId="tipoComparacion"
                        id="tipoComparacion"
                        value={state.valorComparacion}
                        onChange={handleMovimiento}
                        label="tipoComparacion"
                      >
                        <MenuItem value="1">Detecta movimiento</MenuItem>
                      </Select>
                    </FormControl>
                  ) : !silobolsa ? (
                    <h5 className={classes.error}>
                      Porfavor seleccione una condición
                    </h5>
                  ) : null}
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            {state.supervisada && (
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
              >
                {(state.supervisada === "LOCAL" ||
                  state.supervisada === "COMPARTIDA") && (
                    <Grid
                      container
                      style={{ width: "100%" }}
                      direction="row"
                      justify="center"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        style={{
                          textAlign: "center",
                          paddingBottom: "0px",
                          marginBottom: "0px",
                        }}
                      >
                        <h5 style={{ paddingBottom: "0px", marginBottom: "0px" }}>
                          Entrega de alertas
                        </h5>
                      </Grid>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.enviaMail}
                            onChange={handleChange}
                            name="enviaMail"
                            color="primary"
                          />
                        }
                        label="eMail"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.enviaSMS}
                            onChange={handleChange}
                            name="enviaSMS"
                            color="primary"
                          />
                        }
                        label="SMS"
                      />
                      {(state.enviaSMS || state.enviaMail) && (
                        <Grid
                          item
                          xs={12}
                          style={{
                            textAlign: "center",
                            marginLeft: "13px",
                            paddingBottom: "0px",
                            marginBottom: "0px",
                            width: "0px",
                          }}
                        >
                          <TextField
                            id="outlined-multiline-static"
                            label="Mensaje de alerta*"
                            multiline
                            fullWidth
                            rows={2}
                            value={
                              state.mensajeAlerta
                                ? state.mensajeAlerta
                                : defaultMSG
                            }
                            onChange={onChangeMSG}
                            //defaultValue={defaultMSG}
                            variant="outlined"
                          />
                        </Grid>
                      )}
                    </Grid>
                  )}
              </Grid>
            )}
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="start"
            spacing={1}
          >
            <ShowResponse callback={callback} />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="start"
              spacing={1}
            >
              <Grid item xs={6} md={6} lg={6}>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}
                  style={{
                    marginTop: "1em",
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                  }}
                >              
                  GUARDAR                
                </Button>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
